import { createSlice } from "@reduxjs/toolkit";

const valuesLength = 30;
const sensorPlacementMinIndex = 3;
const sensorPlacementMaxIndex = 30;

const initialState = {
  default: { checkStatus: new Array(valuesLength).fill(false) },
  value: { checkStatus: new Array(valuesLength).fill(false) },
  firstWindIsShowing: false,
  selectedZone: null,
  zoneGroup: [false, false, false],
  selectedHours: "07-12 00:00",
  shadingDate: null,
  flag: false,
  windRiskIsLoading: false,
  sensorPlacementIsLoading: false,
  shadingProgressionIsLoading: false,
  sunMovementIsLoading: false,
  // Wind alarm (sensors + windows) toggled per shading-control scenario name
  windAlarmSensors: {},
  windAlarmSensorsIsLoading: false,
  windAlarmWindowsIsLoading: false,
};

const shadingSystemSlice = createSlice({
  name: "shadingSystem",
  initialState,
  reducers: {
    setZone: (state, action) => {
      state.selectedZone = action.payload[0];
      state.zoneGroup[action.payload[0]] = !state.zoneGroup[action.payload[0]];
    },
    setShadingDate: (state, action) => {
      state.shadingDate = action.payload;
    },
    toggleWindRisk: (state, action) => {
      state.value.checkStatus[action.payload] =
        !state.value.checkStatus[action.payload];
    },
    setFirstWindIsShowing: (state) => {
      state.firstWindIsShowing = true;
    },
    hide: (state) => {
      state.value = false;
    },
    setDefaultShading: (state) => {
      state.value = state.default;
    },
    resetSensorPlacement: (state) => {
      state.zoneGroup = [false, false, false, false];
      state.default.checkStatus = [false, false, false, false, false];
      state.value.checkStatus = [false, false, false, false, false];
    },
    setSelectedHours: (state, action) => {
      state.selectedHours = action.payload;
    },
    toggleFlag: (state, action) => {
      state.flag = !state.flag;
    },
    deselectSensorPosition: (state) => {
      state.value.checkStatus = state.value.checkStatus.map((item, index) =>
        index >= sensorPlacementMinIndex && index <= sensorPlacementMaxIndex
          ? false
          : item,
      );
      state.zoneGroup = [false, false, false, false];
    },
    deselectWindRisk: (state) => {
      state.value.checkStatus[0] = false;
    },
    deselectShadingProgression: (state) => {
      state.value.checkStatus[2] = false;
    },
    setWindRiskIsLoading: (state, action) => {
      state.windRiskIsLoading = action.payload;
    },
    setSensorPlacementIsLoading: (state, action) => {
      state.sensorPlacementIsLoading = action.payload;
    },
    setShadingProgressionIsLoading: (state, action) => {
      state.shadingProgressionIsLoading = action.payload;
    },
    setSunMovementIsLoading: (state, action) => {
      state.sunMovementIsLoading = action.payload;
    },
    toggleWindAlarmSensors: (state, action) => {
      const scenario = action.payload;
      const isCurrentlyActive = !!state.windAlarmSensors[scenario];
      state.windAlarmSensors = isCurrentlyActive ? {} : { [scenario]: true };
    },
    deselectWindAlarmSensors: (state) => {
      state.windAlarmSensors = {};
    },
    setWindAlarmSensorsIsLoading: (state, action) => {
      state.windAlarmSensorsIsLoading = action.payload;
    },
    setWindAlarmWindowsIsLoading: (state, action) => {
      state.windAlarmWindowsIsLoading = action.payload;
    },
  },
});

export const {
  toggleWindRisk,
  setFirstWindIsShowing,
  setDefaultShading,
  setZone,
  resetSensorPlacement,
  setSelectedHours,
  toggleFlag,
  deselectSensorPosition,
  deselectWindRisk,
  deselectShadingProgression,
  setWindRiskIsLoading,
  setShadingDate,
  setSensorPlacementIsLoading,
  setShadingProgressionIsLoading,
  setSunMovementIsLoading,
  toggleWindAlarmSensors,
  deselectWindAlarmSensors,
  setWindAlarmSensorsIsLoading,
  setWindAlarmWindowsIsLoading,
} = shadingSystemSlice.actions;

export default shadingSystemSlice.reducer;
